import React from 'react';
import Select from 'react-select';
import FormControl from 'react-bootstrap/FormControl';
import DateTimePicker from 'react-datetime-picker';

import FieldCity from '../../common/FieldCity';
import FieldState from '../../common/FieldState';
import FieldCountry from '../../common/FieldCountry';
import FieldController from '../../../controller/FieldController';
import Filter from '../../../components/filter/FilterPannel';
import Const from '../../../util/Constants';
import Util from '../../../util/Util';
import { FaPlus, FaTrash } from 'react-icons/fa';
import AutomationModuleSelect from './AutomationModuleSelect';
import AutomationUtil from './AutomationUtil';

class AutomationModelUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.models = props.models;
    
    this.SetFieldList = [];
    if(props.model) {
      const fields = FieldController.getFilterFields(this.models[props.model].fields);
      for (let i = 0; i < fields.length; i++) {
        this.SetFieldList.push({
          id: fields[i].id, value: fields[i].fieldKey,
          type: fields[i].field_type, label: fields[i].label_name, status: 1
        });
      }
    }

    const modelUpdates = this.getUpdates(props.value);
    props.onUpdateChanged(modelUpdates);
    this.state = { updates: modelUpdates };
  }

  UNSAFE_componentWillReceiveProps(props) {

    const modelUpdates = this.getUpdates(props.value);    
    this.SetFieldList = [];
    if(props.model) {
      const fields = FieldController.getFilterFields(this.models[props.model].fields);
      for (let i = 0; i < fields.length; i++) {
        this.SetFieldList.push({
          id: fields[i].id, value: fields[i].fieldKey,
          type: fields[i].field_type, label: fields[i].label_name, status: 1
        });
      }
    }

    this.setState({ ...this.state, updates: modelUpdates });
  }

  getUpdates = updates => updates.map(update => {
    const model = update.model ? update.model : 'lead';
    const fields = [];
    const fieldList = FieldController.getFilterFields(this.models[model].fields);
    for (let i = 0; i < fieldList.length; i++) {
      fields.push({
        id: fieldList[i].id, value: fieldList[i].fieldKey,
        type: fieldList[i].field_type, label: fieldList[i].label_name
      });
    }

    const field = fields.find(field => field.value === update.field);
    if (!field) {
      return { };
    }

    const action = update.action ? AutomationUtil.Options.find(action => action.value === update.action)
      : AutomationUtil.Options[0];
    const fOpt = this.getOptionField(action, field.type);
    const options = this.getOptions(model, fOpt, field.value, field.type, update.value);
    return { model, field, fields, action, value: update.value, ...fOpt, ...options };
  });

  getOptionField = (action, type) => {
    const isStaticAssign = !action || (action && action.value === AutomationUtil.StaticAssign);
    const isFieldAssign = action && action.value === AutomationUtil.FieldAssign;
    const isRelatableAssign = action && action.value === AutomationUtil.RelatableAssign;

    const isText = FieldController.showTextFilter(type, Filter.Equals);
    const isDate = type === Const.Date || type === Const.DateTime;
    const isNumber = type === Const.Decimal || type === Const.Number;
    const isFrom = FieldController.showDateFrom(type, Filter.Equals);
    const isTo = FieldController.showDateTo(type, Filter.Equals);
    const isCity = FieldController.showCity(type, Filter.Equals);
    const isState = FieldController.showState(type, Filter.Equals);
    const isCountry = FieldController.showCountry(type, Filter.Equals);
    const isSelect = FieldController.showSelect(type, Filter.Equals);
    return { isStaticAssign, isFieldAssign, isRelatableAssign, isText, isDate, isNumber,
      isFrom, isTo, isCity, isState, isCountry, isSelect };
  }

  getOptions = (model, fOpt, field, type, value) => {
    if (!value) value = '';
    let select = '', options = [], from = null, to = null;
    let isMulti = type.includes('multiselect');
    if (fOpt.isCity) {
      options = FieldController.getOptions({ field_type: Const.City });
    } else if (fOpt.isState) {
      options = FieldController.getOptions({ field_type: Const.State });
    } else if (fOpt.isCountry) {
      options = FieldController.getOptions({ field_type: Const.Country });
    } else if (fOpt.isSelect) {
      options = FieldController.getOptions(this.models[model].fields[field]);
    } else if (fOpt.isFrom || fOpt.isTo) {
      if (value.value) {
        const dates = value.value.split(Const.Opt);
        from = Util.serverStringDateTimeToDate(dates[0]);
        to = Util.serverStringDateTimeToDate(dates[1]);
      } else { from = null; to = null; }
    }
    select = isMulti ? options.filter(option => value.includes(`~${option.value}~`))
      : options.find(option => parseInt(value) === option.value);
    return { select, options, from, to };
  }

  add = () => this.setState({ ...this.state, updates: [...this.state.updates, { ...this.value }] });
  delete = index => {
    let updates = [...this.state.updates];
    updates = updates.filter((_, i) => i !== index);
    this.setState({ ...this.state, updates: [...updates] });
  }

  fieldChange = (i, field) => {
    const updates = [...this.state.updates];
    let fOpt = {}, options = {};
    if(field) {
      fOpt = this.getOptionField(updates[i].action, field.type);
      options = this.getOptions(updates[i].model, fOpt, field.value, updates[i].value ? updates[i].value : '');
    }
    updates[i] = { ...updates[i], ...fOpt, ...options, field: field };
    this.props.onUpdateChanged(updates);
    this.setState({ ...this.state, updates: [...updates] });
  }

  onSelect = (i, select) => {
    const value = select === null ? '' : Array.isArray(select) ?
      `~${select.map(val => val.value).join('~')}~` : `${select.value}`;
    const updates = [...this.state.updates];
    updates[i] = { ...updates[i], select: select, value };
    this.props.onUpdateChanged(updates);
    this.setState({ ...this.state, updates: [...updates] });
  }

  onDateChange = (i, source, date) => {
    const updates = [...this.state.updates];
    let value = '';
    const from = updates[i].from;
    const to = updates[i].to;
    if (source === 'from' && date !== null && to !== null) {
      value = `${Util.dateToServerDateTime(date)}${Const.Opt}${Util.dateToServerDateTime(to)}`;
    } else if (source === 'from' && date !== null && to === null) {
      value = `${Util.dateToServerDateTime(date)}${Const.Opt}`;
    } else if (source === 'from' && date === null && to !== null) {
      value = `${Util.dateToServerDateTime(date)}${Const.Opt}${Util.dateToServerDateTime(to)}`;
    } else if (source === 'to' && from !== null && date !== null) {
      value = `${Util.dateToServerDateTime(from)}${Const.Opt}${Util.dateToServerDateTime(date)}`;
    } else if (source === 'to' && from !== null && date === null) {
      value = `${Util.dateToServerDateTime(from)}${Const.Opt}`;
    } else if (source === 'to' && from === null && date !== null) {
      value = `${Const.Opt}${Util.dateToServerDateTime(date)}`;
    }
    if (source === 'from') updates[i] = { ...updates[i], value, from: date };
    else updates[i] = { ...updates[i], value, to: date };
    this.props.onUpdateChanged(updates);
    this.setState({ ...this.state, updates: [...updates] });
  }

  onTextChanged = (i, value) => {
    const updates = [...this.state.updates];
    updates[i].value = value;
    this.props.onUpdateChanged(updates);
    this.setState({ ...this.state, updates: [...updates] });
  }

  onModelChange = (index, field, model) => {
    const updates = [ ...this.state.updates];
    const fields = [];
    if(model) {
      const fieldList = FieldController.getFilterFields(this.models[model].fields);
      for (let i = 0; i < fieldList.length; i++) {
        fields.push({
          id: fieldList[i].id, value: fieldList[i].fieldKey,
          type: fieldList[i].field_type, label: fieldList[i].label_name
        });
      }
    }
    updates[index]['model'] = model;
    updates[index]['fields'] = fields;
    this.setState({ ...this.state, updates });
  }

  actionChange = (i, action) => {
    const updates = [...this.state.updates];
    const fOpt = this.getOptionField(action ? action : AutomationUtil.Options[0], updates[i].field.type);
    updates[i] = { ...updates[i], ...fOpt, action: action ? action : AutomationUtil.Options[0] };
    this.props.onUpdateChanged(updates);
    this.setState({ ...this.state, updates: [...updates] });
  }

  onFieldAssignChanged = (i, field) => {
    const updates = [...this.state.updates];
    updates[i].value = field ? field.value : field;
    this.props.onUpdateChanged(updates);
    this.setState({ ...this.state, updates: [...updates] });
  }

  render() {
    return(
      <>
        <div className="formhead col-md-12"><h4>Field Updation <FaPlus onClick={this.add} /> </h4></div>
        
        { this.state.updates.map((update, i) => {
          return <div key={`condition_${i}`} className="col-md-12">
            <div className="condition-select-div">
              <AutomationModuleSelect
                onChange={(field, model) => this.onModelChange(i, field, model)}
                model={update.model}
                models={this.models}
                size={6} />
              
              <Select value={update.field} className="col-md-6"
                onChange={selected => this.fieldChange(i, selected)}
                options={update.fields} isSearchable={true} isClearable={true} />

              <Select value={update.action} className="col-md-6"
                onChange={selected => this.actionChange(i, selected)}
                options={AutomationUtil.Options} isSearchable={true} isClearable={true} />

              <div className="condition-select value-float col-md-4">
                  { update.isFieldAssign ?
                    <Select value={this.SetFieldList.find(field => field.value === update.value )}
                      className="mr-sm-2"
                      onChange={selected => this.onFieldAssignChanged(i, selected)}
                      options={this.SetFieldList} isSearchable={true} isClearable={true} />
                  : null
                }

                { update.isStaticAssign && update.isText ?
                  <FormControl type="text" placeholder="Value" value={update.value}
                    onChange={event => this.onTextChanged(i, event.target.value)} />
                  : null
                }
                { update.isStaticAssign && update.isDate ?
                  <DateTimePicker value={update.to} format="dd-MM-y"
                    onChange={date => this.onDateChange(i, 'to', date)} />
                  : null
                }
                { update.isStaticAssign && update.isNumber ?
                  <FormControl type="number" placeholder="Value" value={update.value}
                    onChange={event => this.onTextChanged(i, event.target.value)} />
                  : null
                }
                { update.isStaticAssign && update.isSelect ?
                  <Select value={update.select} options={update.options}
                    onChange={selected => this.onSelect(i, selected)} isSearchable={true}
                    isClearable={true} isMulti={update.field.type.includes('multiselect')} />
                  : null
                }
                {update.isCity ?
                  <FieldCity defaultValue={update.select} isMulti={false}
                    onCitySelected={selected => this.onSelect(i, selected)} />
                  : null
                }
                { update.isStaticAssign && update.isState ?
                  <FieldState defaultValue={update.select} isMulti={false}
                    onStateSelected={selected => this.onSelect(i, selected)} />
                  : null
                }
                { update.isStaticAssign && update.isCountry ?
                  <FieldCountry defaultValue={update.select} isMulti={false}
                    onSelected={selected => this.onSelect(i, selected)} />
                  : null
                }
                &nbsp;&nbsp;
                <FaTrash onClick={() => this.delete(i)} />
              </div>
            </div>
          </div>
        })
      }
    </>); 
  }
}
export default AutomationModelUpdate;